import React from 'react';

const FormattedContent = ({ content }) => {
    const formatContent = (text) => {
        if (!text || typeof text !== 'string') return '';

        return text
            .replace(/&#160;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&nbsp;/g, ' ')
            .replace(/nbsp/g, ' ')
            .replace(/comma/g, ',')
            .replace(/\r\n|\n/g, '<br />')
            .trim();
    };

    const cleanedContent = formatContent(content);

    // Tách đoạn văn dựa trên hai lần xuống dòng
    const lines = cleanedContent.split('<br />');

    return (
        <>
            {lines.map((line, index) => (
                <p key={index} dangerouslySetInnerHTML={{ __html: line }} />
            ))}
        </>
    );
};

export default FormattedContent;
